import { IMemberProps } from '../../../../../common/interface/props';
import ProgressForm from '../../../../form/progress-form';
import Container from '../../../../UI/atoms/Container';
import Grid from '../../../../UI/atoms/Grid';

function Progress({ solType, text }: IMemberProps) {
  return (
    <Container>
      <Grid top={40}>
        <ProgressForm solType={solType} />
      </Grid>
    </Container>
  );
}

export default Progress;
